
import { defineComponent } from 'vue'
import Page from '@/components/Page.vue'
import DatePicker from '@/components/DatePicker.vue'
import AppHeader from '@/components/AppHeader.vue'
import router from '@/router'
import { useMediaQuery } from '@/composables/useMediaQuery'

export default defineComponent({
  name: 'Home',

  components: {
    DatePicker,
    Page,
    AppHeader
  },

  setup () {
    return {
      ...useMediaQuery()
    }
  },

  data () {
    return {
      birthDay: ''
    }
  },

  methods: {
    handleGenerateClicked () {
      router.push({ path: 'calendar', query: { birthDay: this.birthDay } })
    }
  }
})
